<template>
  <div class="w1Pc">
    <div class="warn1_title">
      <div
        class="popup-type1-title"
        :class="{ 'popup-type1-title_green': treatType }"
      >
        <template v-if="itemData.analyzeResult && itemData.warnType == 5"
          >{{ "道路" }}-{{ "污染识别" }}</template
        >
        <template
          v-else-if="
            itemData.warnType == 3 ||
            itemData.warnType == 150 ||
            itemData.warnType == 18 ||
            itemData.warnType == 1003 ||
            itemData.warnType == 1004 ||
            itemData.warnType == 1005 ||
            itemData.warnType == 1014
          "
        >
          {{ itemData.eventName }}
        </template>
        <template v-else-if="itemData.warnType == 100">{{
          itemData.typeName + "-" + "高频高辐"
        }}</template>
        <template v-else-if="itemData.warnType == 6044">{{
          itemData.typeName + "-" + itemData.eventName
        }}</template>
        <template v-else>
          {{ itemData.typeName }}-{{
            itemData.metric +
            (itemData.warnType === 1 && itemData.metric === "TSP"
              ? "告警"
              : itemData.warnType === 1 && itemData.metric === "VDM浓度"
              ? "告警"
              : itemData.warnType === 1
              ? "超标"
              : itemData.warnType === 2
              ? "超低"
              : itemData.warnType === 99
              ? "恒值"
              : itemData.warnType == 10
              ? "持续超标"
              : itemData.warnType == 11
              ? "三倍超标"
              : "")
          }}
        </template>
      </div>
      <div class="popup-type1-time" v-if="itemData.warnType == 5">
        {{ itemData.createTime ? itemData.createTime.slice(5, 16) : "" }}
      </div>
      <div class="popup-type1-time" v-else>
        {{ itemData.eventTime ? itemData.eventTime.slice(5, 16) : "" }}
      </div>
    </div>

    <div class="warn1_content">
      <div class="warn1_state">
        闭环控制状态:
        <span :class="{ done_green: treatType }">{{ handleState_ }}</span>
      </div>
      <div class="warn1_branchFac" v-if="itemData.branchFactory">
        所属区域:
        <span>{{ itemData.branchFactory }}</span>
      </div>
      <div class="warn1_position">
        发生位置:
        <span>{{ itemData.deviceName }}</span>
        <span
          style="
            font-size: 16px;
            color: rgb(204, 204, 204);
            display: block;
            text-align: center;
            padding: 5px 0;
          "
        >
          {{
            sourceData && sourceData.length > 0 && itemData.warnType != 5
              ? "相关排放源数量(" + sourceData.length + ")"
              : ""
          }}
        </span>
      </div>
      <div class="warn1_branchFac" v-if="customerId == 53">
        超标原因:
        <span>{{ itemData.reason ? itemData.reason : "无" }}</span>
      </div>
      <div class="warn1_branchFac" v-if="customerId == 53">
        处理措施:
        <span>{{ itemData.measure ? itemData.measure : "无" }}</span>
      </div>
      <template v-if="itemData.warnType == 5">
        <div class="warn1_road_info">
          统计时间:
          <span>
            {{ itemData.analyzeResult.startTime }} ~
            {{
              itemData.analyzeResult.endTime
                ? itemData.analyzeResult.endTime.slice(11, 19)
                : ""
            }}
          </span>
        </div>
        <div class="warn1_road_info">
          全厂PM10均值:
          <span>
            {{
              itemData.analyzeResult.pm10AvgFactory
                ? itemData.analyzeResult.pm10AvgFactory
                : "--"
            }}
            μg/m³
          </span>
        </div>
        <div class="warn1_road_info">
          PM10均值:
          <span>
            {{
              itemData.analyzeResult.pm10AvgRoad
                ? itemData.analyzeResult.pm10AvgRoad
                : "--"
            }}
            μg/m³
          </span>
        </div>
        <div class="warn1_charts new-chart-style" v-if="itemData.chartRoadPM10">
          <div class="warn1_charts_inner" ref="chartRoadPM10"></div>
        </div>
        <div
          class="warn1_road_info"
          v-if="itemData.analyzeResult && itemData.analyzeResult.vdmAvgRoad"
        >
          VDM均值:
          <span>{{ itemData.analyzeResult.vdmAvgRoad }} μg/m³</span>
        </div>
        <div
          class="warn1_charts new-chart-style"
          v-if="itemData.analyzeResult && itemData.analyzeResult.vdmAvgRoad"
        >
          <div class="warn1_charts_inner" ref="chartRoadVDM"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ["itemData"],
  watch: {
    itemData: {
      handler(newVal, oldVal) {
        console.log(this.itemData, "itemData");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.w1pc {
  .warn1_title {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid;
    border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
    justify-content: space-between;
    .popup-type1-title {
      height: 30px;
      font-size: 22px;
      font-weight: 500;
      color: #ff7373;
      line-height: 30px;
      display: flex;
      align-items: center;
      // flex-wrap: nowrap;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      text-align: left;
      &::before {
        content: "";
        display: block;
        width: 7px;
        height: 7px;
        background: #ff7373;
        box-shadow: 0px 0px 7px 0px #df3131;
        border: 1px solid #da3636;
        border-radius: 50%;
        display: inline-block;
        margin-right: 16px;
      }
    }
    .popup-type1-time {
      // height: 14px;
      padding-bottom: 5px;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;
      width: 90px;
    }
  }
  .warn1_content {
    margin-top: 20px;
    .warn1_state {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      margin-bottom: 7px;
      span {
        color: #f4c48f;
        font-weight: 500;
      }
    }
    .warn1_branchFac {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 7px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .warn1_road_info {
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 30px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .warn1_position {
      //height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .new-chart-style {
      margin-bottom: 10px;
    }
  }
  .warn1_box {
    margin-top: 20px;
    width: 100%;
    height: 126px;
    background: rgba(0, 0, 0, 0.42);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.66);
    padding: 13px 79px;

    .smallBox {
      @include bg-box(100%, 100px, "warn1_bg.png");
      text-align: center;
      padding-top: 10px;
      .warn1_type_name {
        height: 16px;
        font-size: 16px;
        color: #99f5ff;
        line-height: 16px;
        margin-bottom: 15px;
      }
      .warn1_type_num {
        height: 32px;
        font-size: 32px;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 5px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.32);
      }
      .cemsDesc {
        font-size: 24px;
      }
      .warn1_type_unit {
        height: 12px;
        font-size: 12px;
        color: #aaaaaa;
        line-height: 12px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.3);
      }
    }
  }
  .warn1_charts {
    width: 390px;
    height: 135px;
    margin-top: 10px;
    .warn1_charts_inner {
      width: 390px;
      height: 135px;
    }
  }
}
</style>